// 角色
import request from "@/utils/interceptor.js";

const roleApi = {
  getRoleList(params) {
    return request({ url: `/api/pas/role-info`, method: "get", params });
  },
  addRole(data) {
    return request({ url: `/api/pas/role-info`, method: "post", data });
  },
  editRole(data) {
    return request({ url: `/api/pas/role-info/${data.id}`, method: "put", data });
  },
  delRole(id) {
    return request({ url: `/api/pas/role-info/${id}`, method: "delete" });
  },
  //用户和角色绑定
  getUserRoles(params) {
    return request({ url: `/api/pas/user-and-role`, method: "get", params });
  },
  bindUser(data) {
    return request({ url: `/api/pas/user-and-role`, method: "post", data });
  },
  bindUserEdit(data) {
    return request({ url: `/api/pas/user-and-role/${data.id}`, method: "put", data });
  },
};

export default roleApi;
